<script>
  export let name;
  export let lastName;
  export let age;
</script>

<div class="Person">
  <p>👤{name} - {lastName} - {age}</p>
</div>